export default "__VITE_ASSET__QAiaH4YN__"